import { createSelector } from '@ngrx/store';
import {
	IWorkOrderState,
	workOrderEntitySelector,
} from '@app/pages/cmms/components/work-order/state/work-order.reducer';
import { AuUtilsFunctions } from '@app/shared';

import {
	defaultPageSize,
	paginationQueryVariables,
} from '@app/pages/cmms/configs/pagination-query-variables';

export const selectWorkOrderState = state => state.cmms.workOrderState;

export const allWorkOrders = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => {
		return {
			workOrders: workOrderEntitySelector.selectAll(state),
			workOrderPagination: state.workOrderPagination,
		};
	}
);

export const workOrderAuPagination = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.workOrderAuPagination
);

export const workOrderPageSize = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) =>
		state.workOrderAuPagination?.first ??
		state.workOrderAuPagination?.last ??
		defaultPageSize
);

export const workOrderQueryVariables = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.workOrderQueryVariables
);

export const workOrderQueryVariablesWithoutPagination = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => {
		if (state.workOrderQueryVariables) {
			return AuUtilsFunctions.excludeObjectKeys(
				state.workOrderQueryVariables,
				paginationQueryVariables
			);
		}
	}
);

export const workOrdersTableColumnKeys = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => {
		return (state.tableColumnsConfig ?? []).map(column => column.key);
	}
);

export const workOrdersTableExportUrlQuery = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.exportUrlQuery
);

export const workOrdersIsLoading = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.workOrderIsLoading
);

export const workOrderTotal = createSelector(
	selectWorkOrderState,
	workOrderEntitySelector.selectTotal
);

export const editWorkOrder = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.workOrderEdit
);

export const workOrderData = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.workOrderData
);

export const workOrdersIsExportable = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.isExportable
);

export const workOrderExportTableData = createSelector({
	isExportable: workOrdersIsExportable,
	queryVariables: workOrderQueryVariablesWithoutPagination,
	columnKeys: workOrdersTableColumnKeys,
	exportUrlQuery: workOrdersTableExportUrlQuery,
});

export const workOrderSelectedCalendarDate = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => state.selectedCalendarDate
);

export const workOrderMap = createSelector(
	selectWorkOrderState,
	(state: IWorkOrderState) => workOrderEntitySelector.selectEntities(state)
);
